import type { FC } from 'react'
import * as Root from '@radix-ui/react-switch'

const Switch: FC<Root.SwitchProps> = ({ className, ...props }) => {
  const rootClasses = [
    'all-unset',
    className,
    'w-8 h-full p-0.5 bg-gray-300/50 rounded-full inline-flex justify-start items-start gap-2 transition-opacity',
    'data-[state=checked]:bg-blue-500',
    'disabled:cursor-not-allowed disabled:opacity-50',
  ].join(' ')
  const thumbClasses = [
    'block w-4 h-4 bg-white rounded-full transition-transform duration-100 will-change-transform',
    'data-[state=checked]:translate-x-3',
  ].join(' ')
  return (
    <Root.Root className={rootClasses} {...props}>
      <Root.Thumb className={thumbClasses} />
    </Root.Root>
  )
}

export default Switch
